module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "copyright-page"
    }
  }, [_c('p', {
    staticClass: "copyt1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_iv",
      "title": "iv"
    }
  }, [_vm._v("Copyright © 1971 by Charles Willeford")])]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Cover © 2020 Abrams")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Published in 2020 by The Overlook Press, an imprint of ABRAMS. All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, mechanical, electronic, photocopying, recording, or otherwise, without written permission from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Library of Congress Control Number: 2019938599")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("ISBN: 978-1-4197-4045-9"), _c('br'), _vm._v("eISBN: 978-1-68335-801-5")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("Abrams books are available at special discounts when purchased in quantity for premiums and promotions as well as fundraising or educational use."), _c('br'), _vm._v("Special editions can also be created to specification. For details, contact specialsales@abramsbooks.com or the address below.")]), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/copya.jpg"
    }
  }), _c('br'), _c('strong', [_vm._v("ABRAMS")]), _vm._v(" The Art of Books"), _c('br'), _vm._v("195 Broadway, New York, NY 10007"), _c('br'), _c('a', {
    attrs: {
      "href": "http://abramsbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("abramsbooks.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fad2c05a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copy.vue
// module id = 63
// module chunks = 0